<script setup lang="ts">
/**
 * @author Giorgi Tseradze
 *
 */

//
import { useMainStore } from "@/store/main/index";
import { SecondaryDataInterface } from "@/types/ContentType";

const props = defineProps<{
  contentData: SecondaryDataInterface;
}>();

const mainStore = useMainStore();
</script>

<template>
  <section>
    <video
      class="img-absolute"
      muted
      autoplay
      loop
      preload="auto"
      playsinline
      :poster="contentData?.data?.list?.[0]?.image?.[0]?.url"
    >
      <source
        :media="`(max-width: ${mainStore.breakpoints.mobile}px)`"
        :src="props?.contentData?.data?.list?.[0]?.video?.videoFile?.url"
        type="video/mp4"
      />
      <source
        :src="props?.contentData?.data?.list?.[0]?.video?.videoFile?.url"
        type="video/mp4"
      />
      Your browser does not support the video tag.
    </video>
  </section>
</template>

<style lang="scss"></style>
